import { useMutation } from '@tanstack/react-query'

import { visitorParkingAPI } from '@/api/new-api'
import { VisitorData } from '@/pages/visitor-parking/visitor-parking.types'

interface CreateVisitorParkingSessionRequest extends VisitorData {
  duration: number
}

interface CreateVisitorParkingSessionResponse {
  sessionId: number
  ticketNumber: string
  amount: number
  clientSecret: string | null
  visitorId: number
}

export const createVisitorParkingSession = async (data: CreateVisitorParkingSessionRequest) => {
  const response = await visitorParkingAPI.post<CreateVisitorParkingSessionResponse>(
    `/visitor-parking/visitor`,
    data,
  )
  return response.data
}

export const useCreateVisitorParkingSession = () => {
  return useMutation({
    mutationFn: createVisitorParkingSession,
  })
}
